import { Users } from '../models/User.tsx';

type PinIdentity = {
    id?: string | null;
    userName?: string | null;
    userDocId?: string | null;
};

export function livePinLookup(users: Users[]): Map<string, string> {
    const map = new Map<string, string>();
    for (const user of users) {
        if (user.pin == null || user.pin === '') continue;
        if (user.id) map.set(user.id, user.pin);
        if (user.userName) map.set(user.userName.toLowerCase(), user.pin);
    }
    return map;
}

export function livePin(
    lookup: Map<string, string>,
    identity: PinIdentity,
    fallback?: string | null
): string {
    const fromId = identity.id ? lookup.get(identity.id) : undefined;
    if (fromId) return fromId;
    const fromDoc = identity.userDocId ? lookup.get(identity.userDocId) : undefined;
    if (fromDoc) return fromDoc;
    const fromName = identity.userName ? lookup.get(identity.userName.toLowerCase()) : undefined;
    if (fromName) return fromName;
    return fallback ?? '';
}

export function withLivePins<T extends PinIdentity & { pin?: string | null }>(
    items: T[],
    lookup: Map<string, string>
): T[] {
    return items.map(item => {
        const pin = livePin(lookup, item, item.pin);
        return pin === item.pin ? item : { ...item, pin };
    });
}

export function withLivePlayerPin<T extends { player?: PinIdentity & { pin?: string | null } | null }>(
    item: T,
    lookup: Map<string, string>
): T {
    if (!item.player) return item;
    const pin = livePin(lookup, item.player, item.player.pin);
    if (pin === item.player.pin) return item;
    return { ...item, player: { ...item.player, pin } };
}
